import { useState } from "react";
import { api } from "../api";
import { today } from "../constants";
import Card from "./ui/Card";
import Select from "./ui/Select";
import Input from "./ui/Input";
import Btn from "./ui/Btn";

export default function AssignmentsMgmt({
  reviewers,
  stations,
  assignments,
  toast,
  refresh,
  user,
}) {
  const isReadOnly = user?.role === "auditor";
  const [form, setForm] = useState({
    reviewer_id: "",
    station_id: "",
    start_date: today(),
  });
  const [fR, setFR] = useState("");
  const filtered = fR
    ? assignments.filter((a) => a.reviewer_id === parseInt(fR))
    : assignments;
  const grouped = filtered.reduce((acc, a) => {
    if (!acc[a.reviewer_id])
      acc[a.reviewer_id] = { name: a.reviewer_name, items: [] };
    acc[a.reviewer_id].items.push(a);
    return acc;
  }, {});
  const assignedIds = new Set(assignments.map((a) => a.station_id));
  const unassigned = stations.filter(
    (s) => s.active && !assignedIds.has(s.id)
  );

  const add = async () => {
    if (!form.reviewer_id || !form.station_id) {
      toast("اختر المراجع والمحطة", "warning");
      return;
    }
    try {
      await api("/assignments", {
        method: "POST",
        body: {
          reviewer_id: parseInt(form.reviewer_id),
          station_id: parseInt(form.station_id),
          start_date: form.start_date,
        },
      });
      toast("✅ تم التعيين");
      refresh();
    } catch (e) {
      toast("خطأ: " + e.message, "error");
    }
  };

  const remove = async (id) => {
    if (!window.confirm("إلغاء التعيين؟")) return;
    await api(`/assignments/${id}`, { method: "DELETE" });
    toast("✅ تم الإلغاء");
    refresh();
  };

  return (
    <div>
      <h2
        style={{
          fontSize: 20,
          fontWeight: 800,
          margin: "0 0 20px",
          color: "#f1f5f9",
        }}
      >
        🔗 تعيين المحطات
      </h2>
      <div style={{ display: "grid", gridTemplateColumns: "340px 1fr", gap: 18 }}>
        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          {!isReadOnly && (
            <Card>
              <h3
                style={{
                  color: "#f1f5f9",
                  margin: "0 0 14px",
                  fontSize: 14,
                  fontWeight: 700,
                }}
              >
                تعيين جديد
              </h3>
              <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                <Select
                  label="المراجع"
                  value={form.reviewer_id}
                  onChange={(v) => setForm((f) => ({ ...f, reviewer_id: v }))}
                  options={reviewers
                    .filter((r) => r.active)
                    .map((r) => ({ value: r.id, label: r.name }))}
                  required
                />
                <Select
                  label="المحطة"
                  value={form.station_id}
                  onChange={(v) => setForm((f) => ({ ...f, station_id: v }))}
                  options={stations
                    .filter((s) => s.active)
                    .map((s) => ({
                      value: s.id,
                      label: s.name + " — " + s.region,
                    }))}
                  required
                />
                <Input
                  label="تاريخ البدء"
                  type="date"
                  value={form.start_date}
                  onChange={(v) => setForm((f) => ({ ...f, start_date: v }))}
                />
                <Btn onClick={add} color="#22c55e" size="lg">
                  🔗 تعيين
                </Btn>
              </div>
            </Card>
          )}
          {unassigned.length > 0 && (
            <Card>
              <h3
                style={{
                  color: "#f59e0b",
                  margin: "0 0 10px",
                  fontSize: 13,
                  fontWeight: 700,
                }}
              >
                ⚠️ غير معينة ({unassigned.length})
              </h3>
              {unassigned.map((s) => (
                <div
                  key={s.id}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "5px 0",
                    borderBottom: "1px solid #0f172a",
                  }}
                >
                  <span style={{ color: "#f59e0b", fontSize: 12 }}>
                    {s.name}
                  </span>
                  <span style={{ color: "#64748b", fontSize: 11 }}>
                    {s.region}
                  </span>
                </div>
              ))}
            </Card>
          )}
        </div>
        <Card>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: 12,
            }}
          >
            <h3
              style={{
                color: "#f1f5f9",
                fontSize: 14,
                fontWeight: 700,
                margin: 0,
              }}
            >
              التعيينات ({assignments.length})
            </h3>
            <div style={{ minWidth: 150 }}>
              <Select
                value={fR}
                onChange={setFR}
                placeholder="الكل"
                options={reviewers.map((r) => ({
                  value: r.id,
                  label: r.name,
                }))}
              />
            </div>
          </div>
          <div style={{ maxHeight: 550, overflowY: "auto" }}>
            {Object.entries(grouped).map(([rid, { name, items }]) => (
              <div key={rid}>
                <div
                  style={{
                    color: "#38bdf8",
                    fontWeight: 700,
                    fontSize: 12,
                    padding: "5px 8px",
                    background: "#0f172a",
                    borderRadius: 6,
                    marginBottom: 3,
                    marginTop: 8,
                  }}
                >
                  👤 {name} ({items.length})
                </div>
                {items.map((a) => (
                  <div
                    key={a.id}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "5px 10px",
                      borderBottom: "1px solid #0f172a",
                    }}
                  >
                    <div>
                      <span style={{ color: "#cbd5e1", fontSize: 12 }}>
                        {a.station_name}
                      </span>
                      <span
                        style={{
                          color: "#64748b",
                          fontSize: 10,
                          marginRight: 6,
                        }}
                      >
                        {a.region}
                      </span>
                    </div>
                    {!isReadOnly && (
                      <button
                        onClick={() => remove(a.id)}
                        style={{
                          background: "#7f1d1d",
                          border: "none",
                          color: "#fca5a5",
                          borderRadius: 5,
                          padding: "2px 7px",
                          cursor: "pointer",
                          fontSize: 10,
                        }}
                      >
                        إلغاء
                      </button>
                    )}
                  </div>
                ))}
              </div>
            ))}
          </div>
        </Card>
      </div>
    </div>
  );
}
